module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl('locashop-loading.gif'),
      "alt": "Carregando..."
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54c8cf1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Loading.vue
// module id = 298
// module chunks = 18